import { Injectable } from '@angular/core';
import {RestHttpService} from "../../../core/services/rest-http.service";
import {NetworkInterface} from "../../network-interfaces/types";
import {Store} from "@ngrx/store";
import {Restangular} from "ngx-restangular";
import {Observable} from "rxjs/Observable";
import {GgwDeviceParam} from "../types";

@Injectable()
export class FeatureGgwDeviceParamService extends RestHttpService<GgwDeviceParam> {
    constructor(private store: Store<any>, restService: Restangular) {
        super('feature-ggw-device-parameters', restService);
    }

    /**
     * Initiates the process to create a single resource through the WebAPI
     * @param {GgwDeviceParam} item
     * @returns {Observable<any>}
     */
    create(item: any): Observable<any> {
        return this.queryAll()
            .post(item);
    }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/ggw-device-params/services/feature-ggw-device-param.service.ts